import get from 'lodash.get';

export const getFormErrorMessage = (errors, field): any => {
  return get(errors, `${field}.message`, null);
};
